import type { FormQuestionSuggestion } from "../types";

export const QUESTION_TYPE_LABEL: Record<FormQuestionSuggestion["type"], string> = {
	text: "Long Answer",
	multiline: "Multiple Line Answer",
	"multiple-select": "Multi-select",
	date: "Date",
	"goal-creation": "Goal Creation",
	"goal-discussion": "Goal Discussion",
	"rating-scale": "Rating Scale",
	"multiple-choice": "Multiple Choice",
	instructions: "Instructions",
	numeric: "Numeric",
};
